import { render } from "./RecordMedia.vue?vue&type=template&id=36355fbc"
import script from "./RecordMedia.vue?vue&type=script&lang=js"
export * from "./RecordMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__